import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';


import {Router} from '@angular/router';
import {CatalogStore} from '@store/catalog.store';
import {STORAGE_CONFIG} from '@core/constants';
import {StorageService} from '../../../services/storage.service';
import {TrackingWebsocket} from '../../../services/websockets/traking-websocket';
import {SessionStore} from '@store/session.store';
import {CartStore} from '@store/cart.store';
import {LucideChevronLeft, LucideHandPlatter, LucideHouse, LucideReceipt, LucideShoppingCart} from '@lucide/angular';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule, LucideHouse, LucideChevronLeft, LucideHandPlatter, LucideReceipt, LucideShoppingCart],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit {
  protected readonly wsService = inject(TrackingWebsocket);


  private readonly sessionStore = inject(SessionStore);
  protected readonly customerName = this.sessionStore.customerName;
  protected readonly selectedTable = this.sessionStore.selectedTable;
  protected readonly orderRestaurantId = this.sessionStore.orderRestaurantId;
  private readonly cartStore = inject(CartStore);
  protected readonly cartCount = this.cartStore.cartCount;
  private readonly store = inject(CatalogStore);
  protected readonly isVisible = this.store.isHeaderVisible;
  protected readonly title = this.store.headerTitle || '';
  protected readonly backRoute = this.store.backRoute;
  protected readonly showBack = this.store.backButton;
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private storageKey = inject(STORAGE_CONFIG);
  private storage = inject(StorageService);

  ngOnInit() {
    const {orderRestaurantId, customerId} = JSON.parse(this.storage.getItem(this.storageKey.session) || '{}');
    if (orderRestaurantId) {
      this.wsService.connect(orderRestaurantId, customerId);
    }
  }

  ngOnDestroy() {
    this.wsService.close();
  }

  async goBack() {
    const route = this.backRoute();
    if (route) {
      await this.router.navigateByUrl(route, {replaceUrl: true});
    } else {
      this.location.back();
    }
  }

  goToTracking() {
    this.router.navigate(['/standard/tracking']);
  }

  goToCart() {
    this.router.navigate(['/standard/cart']);
  }
}
